import Cookies from 'js-cookie';
import get from 'lodash/get';
import { PROP_URL, PROP_ID } from 'redux/models/offices/model';

export const goToOfficePage = (office) => {
  location.href = get(office, PROP_URL, '#');
};

export const setCookieResellerId = (office) => {
  const resellerId = parseInt(get(office, PROP_ID), 10);
  if (resellerId) {
    const options = { expires: 365, path: '/', domain: location.hostname };
    Cookies.set('resellerId', resellerId, options);
  }
};
